import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [require('./app.component.css')]
})
export class AppComponent {
    constructor (private auth: AuthService){
        auth.handleAuthentication();
    }
   
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/app/app.component.ts